module.exports = __webpack_public_path__ + "img/FUNDO_CAPA-1920x793px.b00488d0.png";